/**
 * Constants for form logic evaluation
 */

export const FORM_LOGIC_CALCULATED_FIELDS = [
  "Calculated: BMI",
  "Calculated: Age",
  "Calculated: Score",
  "Gender",
  "State",
];

export const FORM_LOGIC_URL_PARAMETER = "URL Logic Parameter";
